import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { sitesOptions } from "../queries/sitesQueries";
import type { IRetailIntelligenceUpsellResponse, RetailIntelligenceUpsellQueryOptions } from "../types";

export const useRetailIntelligenceUpsell = (
    domain: string,
    options?: RetailIntelligenceUpsellQueryOptions,
): UseQueryResult<IRetailIntelligenceUpsellResponse> => {
    return useQuery(sitesOptions.retailIntelligenceUpsell(domain, options));
};
